import { FilterTypes } from '../filters.service';
export const FILTERS_MOCK = [
    {
        id: 'text_filter',
        type: FilterTypes.text
    },
    {
        id: 'date_filter',
        type: FilterTypes.date
    },
    {
        id: 'select_filter',
        type: FilterTypes.select,
        options: [
            {
                key: 's-1',
                name: 'select one'
            }
        ]
    }
];
//# sourceMappingURL=filters.js.map